export default __webpack_public_path__ + "static/media/tier26.c38dd491.png";